function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  props: {
    color: {
      type: String,
      "default": '#fff'
    },
    simple: Boolean,
    inverse: Boolean,
    height: {
      type: Number,
      "default": 32
    },
    width: {
      type: Number,
      "default": 40
    }
  },
  computed: {
    fillColor: function fillColor() {
      return this.inverse ? '#2D2D2D' : this.color;
    },
    containerStyles: function containerStyles() {
      if (!this.label) {
        return;
      }

      return {
        paddingTop: this.height / 3 + 'px'
      };
    },
    nameStyles: function nameStyles() {
      if (!this.label) {
        return {
          height: this.height + 'px'
        };
      }

      return {
        height: this.height / 1.499 + 'px'
      };
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "rss-ui-logo",
    style: _vm.containerStyles,
    attrs: {
      "itemprop": "logo",
      "itemscope": "itemscope",
      "itemtype": "https://schema.org/ImageObject"
    }
  }, [_c('svg', {
    staticClass: "rss-ui-logo__name",
    style: _vm.nameStyles,
    attrs: {
      "width": !_vm.simple ? '140' : _vm.width,
      "viewBox": "0 0 " + (!_vm.simple ? '245' : '56') + " 56",
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "40",
      "itemprop": "url image"
    }
  }, [!_vm.simple ? _c('path', {
    attrs: {
      "fill": _vm.fillColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M75.135 26.567h4.48c1.516 0 2.806-.192 3.872-.576 1.065-.384 1.938-.917 2.618-1.598a6.081 6.081 0 001.483-2.388 9.16 9.16 0 00.462-2.949c0-2.109-.687-3.756-2.06-4.942-1.373-1.186-3.497-1.779-6.375-1.779h-4.48v14.232zm0 7.676V52H67.71A3.712 3.712 0 0164 48.289V10.174A6.175 6.175 0 0170.175 4h9.44c3.47 0 6.43.358 8.879 1.071 2.449.714 4.448 1.707 5.996 2.982 1.548 1.274 2.674 2.778 3.376 4.513.703 1.735 1.055 3.624 1.055 5.666 0 1.56-.21 3.031-.626 4.415a13.37 13.37 0 01-1.861 3.838 14.376 14.376 0 01-3.031 3.145c-1.198.923-2.576 1.681-4.135 2.274.746.374 1.444.835 2.093 1.384a8.277 8.277 0 011.696 2.009L103.269 52h-10.08c-1.867 0-3.207-.703-4.02-2.109l-7.972-13.934c-.351-.616-.763-1.055-1.235-1.318-.473-.264-1.137-.396-1.994-.396h-2.833zM133.174 14.057c-.323.517-.661.903-1.015 1.161-.355.257-.812.387-1.371.387-.494 0-1.027-.156-1.595-.468-.57-.31-1.215-.66-1.935-1.048a16.179 16.179 0 00-2.466-1.047c-.924-.312-1.976-.468-3.159-.468-2.041 0-3.562.436-4.561 1.306-1 .871-1.499 2.047-1.499 3.53 0 .946.301 1.73.903 2.354.601.622 1.39 1.16 2.369 1.611.977.452 2.095.865 3.352 1.241 1.258.376 2.542.795 3.852 1.257a34.295 34.295 0 013.853 1.63 12.843 12.843 0 013.353 2.384c.977.967 1.767 2.143 2.369 3.53.601 1.385.903 3.057.903 5.012 0 2.172-.376 4.202-1.129 6.093a14.26 14.26 0 01-3.272 4.948c-1.429 1.408-3.191 2.515-5.287 3.32-2.095.807-4.475 1.21-7.14 1.21-1.462 0-2.949-.15-4.464-.452a26.5 26.5 0 01-4.401-1.273 25.524 25.524 0 01-3.997-1.95c-1.247-.753-2.332-1.59-3.256-2.515l3.224-5.093c.236-.388.569-.698.999-.934.43-.237.891-.355 1.387-.355.644 0 1.294.204 1.949.612.656.41 1.397.86 2.224 1.354.828.494 1.779.945 2.854 1.353 1.074.41 2.342.614 3.804.614 1.977 0 3.513-.437 4.61-1.306 1.095-.87 1.644-2.25 1.644-4.144 0-1.094-.302-1.987-.903-2.674-.602-.688-1.392-1.258-2.37-1.709a21.897 21.897 0 00-3.336-1.193 97.919 97.919 0 01-3.836-1.144 28.165 28.165 0 01-3.836-1.547 12.102 12.102 0 01-3.336-2.418c-.979-1-1.769-2.246-2.371-3.739-.601-1.494-.902-3.337-.902-5.529 0-1.762.355-3.482 1.064-5.158.709-1.676 1.751-3.17 3.127-4.48 1.375-1.312 3.063-2.359 5.061-3.143C116.636 4.392 118.925 4 121.505 4c1.439 0 2.841.112 4.207.338 1.363.225 2.658.56 3.884 1 1.225.44 2.369.966 3.432 1.58a15.834 15.834 0 012.854 2.078l-2.708 5.061zM168.118 14.057c-.323.517-.661.903-1.015 1.161-.355.257-.812.387-1.371.387-.494 0-1.027-.156-1.595-.468-.57-.31-1.215-.66-1.935-1.048a16.179 16.179 0 00-2.466-1.047c-.924-.312-1.977-.468-3.159-.468-2.042 0-3.562.436-4.561 1.306-1 .871-1.499 2.047-1.499 3.53 0 .946.301 1.73.902 2.354.602.622 1.391 1.16 2.37 1.611.977.452 2.095.865 3.352 1.241 1.258.376 2.542.795 3.852 1.257a34.295 34.295 0 013.853 1.63 12.821 12.821 0 013.352 2.384c.978.967 1.768 2.143 2.37 3.53.601 1.385.903 3.057.903 5.012 0 2.172-.376 4.202-1.129 6.093a14.273 14.273 0 01-3.272 4.948c-1.429 1.408-3.191 2.515-5.287 3.32-2.095.807-4.475 1.21-7.14 1.21-1.462 0-2.949-.15-4.464-.452a26.5 26.5 0 01-4.401-1.273 25.524 25.524 0 01-3.997-1.95c-1.247-.753-2.332-1.59-3.256-2.515l3.223-5.093c.237-.388.57-.698 1-.934a2.82 2.82 0 011.386-.355c.645 0 1.295.204 1.95.612.656.41 1.397.86 2.224 1.354.828.494 1.779.945 2.854 1.353 1.074.41 2.342.614 3.804.614 1.977 0 3.513-.437 4.61-1.306 1.095-.87 1.643-2.25 1.643-4.144 0-1.094-.301-1.987-.903-2.674-.601-.688-1.391-1.258-2.369-1.709a21.897 21.897 0 00-3.336-1.193 98.47 98.47 0 01-3.837-1.144 28.269 28.269 0 01-3.836-1.547 12.132 12.132 0 01-3.336-2.418c-.978-1-1.768-2.246-2.37-3.739-.601-1.494-.902-3.337-.902-5.529 0-1.762.355-3.482 1.064-5.158.709-1.676 1.751-3.17 3.127-4.48 1.375-1.312 3.063-2.359 5.061-3.143C151.58 4.392 153.869 4 156.449 4c1.439 0 2.841.112 4.207.338 1.363.225 2.658.56 3.884 1 1.225.44 2.369.966 3.432 1.58a15.825 15.825 0 012.853 2.078l-2.707 5.061z"
    }
  }) : _vm._e(), !_vm.simple ? _c('path', {
    attrs: {
      "fill": _vm.fillColor,
      "d": "M171 52.056v-4.608h3.52v4.608H171zM176.727 43.672a9.13 9.13 0 01.608-3.328 8.114 8.114 0 011.76-2.752c.769-.79 1.697-1.419 2.785-1.888 1.088-.47 2.314-.704 3.68-.704 1.834 0 3.391.395 4.672 1.184 1.301.79 2.271 1.824 2.911 3.104l-4.192 1.28a3.642 3.642 0 00-1.44-1.408 3.926 3.926 0 00-1.984-.512c-.618 0-1.194.128-1.727.384a4.114 4.114 0 00-1.408 1.024c-.384.427-.694.95-.928 1.568a6.231 6.231 0 00-.32 2.048c0 .747.117 1.43.351 2.048.235.619.545 1.152.929 1.6.405.448.874.8 1.408 1.056a4.16 4.16 0 001.695.352c.768 0 1.472-.192 2.112-.576.662-.384 1.121-.853 1.377-1.408l4.192 1.28c-.576 1.28-1.526 2.325-2.849 3.136-1.322.81-2.911 1.216-4.767 1.216-1.366 0-2.592-.235-3.681-.704-1.088-.47-2.015-1.099-2.783-1.888A8.913 8.913 0 01177.335 47a9.299 9.299 0 01-.608-3.328zM202.934 52.376c-1.366 0-2.592-.235-3.68-.704-1.088-.47-2.016-1.099-2.784-1.888A8.716 8.716 0 01194.742 47a9.023 9.023 0 01-.608-3.296 9.11 9.11 0 01.608-3.328 8.346 8.346 0 011.728-2.752 8.324 8.324 0 012.784-1.92c1.088-.47 2.314-.704 3.68-.704 1.365 0 2.581.235 3.648.704 1.088.47 2.005 1.11 2.752 1.92a8.114 8.114 0 011.76 2.752 9.13 9.13 0 01.608 3.328c0 1.152-.203 2.25-.608 3.296a8.751 8.751 0 01-1.728 2.784c-.747.79-1.664 1.419-2.752 1.888-1.088.47-2.315.704-3.68.704zm-4.384-8.672c0 .747.106 1.43.32 2.048a5.43 5.43 0 00.928 1.568c.405.448.874.8 1.408 1.056a4.24 4.24 0 001.728.352c.618 0 1.194-.117 1.728-.352a4.172 4.172 0 001.376-1.056 4.59 4.59 0 00.928-1.6 5.747 5.747 0 00.352-2.048c0-.725-.118-1.397-.352-2.016a4.59 4.59 0 00-.928-1.6 3.82 3.82 0 00-1.376-1.024 3.945 3.945 0 00-1.728-.384c-.619 0-1.195.128-1.728.384a4.513 4.513 0 00-1.408 1.056 5.33 5.33 0 00-.928 1.6 6.128 6.128 0 00-.32 2.016zM240.144 52.056h-4.288v-9.408c0-1.344-.235-2.325-.704-2.944-.448-.619-1.077-.928-1.888-.928-.853 0-1.653.33-2.4.992-.747.64-1.28 1.483-1.6 2.528v9.76h-4.288v-9.408c0-1.344-.235-2.325-.704-2.944-.448-.619-1.077-.928-1.888-.928-.832 0-1.632.32-2.4.96-.747.64-1.28 1.483-1.6 2.528v9.792h-4.288V35.288h3.872v3.104c.619-1.088 1.461-1.92 2.528-2.496 1.088-.597 2.325-.896 3.712-.896 1.408 0 2.496.341 3.264 1.024a4.573 4.573 0 011.472 2.528c.683-1.152 1.547-2.027 2.592-2.624 1.045-.619 2.24-.928 3.584-.928 1.024 0 1.867.192 2.528.576a4.164 4.164 0 011.536 1.504c.363.619.608 1.323.736 2.112.149.79.224 1.59.224 2.4v10.464z"
    }
  }) : _vm._e(), _c('path', {
    attrs: {
      "d": "M36 52H26a21.93 21.93 0 00-6.44-15.56A22 22 0 004 30V20a31.93 31.93 0 0122.63 9.37A31.9 31.9 0 0136 52z",
      "fill": "url(#paint0_linear)"
    }
  }), _c('path', {
    attrs: {
      "d": "M18 45.05A7 7 0 114 44.95a7 7 0 0113.999.1z",
      "fill": "url(#paint1_linear)"
    }
  }), _c('path', {
    attrs: {
      "d": "M52 52h-9.969a37.941 37.941 0 00-11.094-26.87A37.738 37.738 0 004.152 14H4V4h.152a47.622 47.622 0 0133.832 14.06A47.89 47.89 0 0152 52z",
      "fill": "url(#paint2_linear)"
    }
  }), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear",
      "x1": "6.25",
      "y1": "36",
      "x2": "38.25",
      "y2": "36",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F8B700"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".51",
      "stop-color": "#F87900"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#AE35DD"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear",
      "x1": "4.001",
      "y1": "45.05",
      "x2": "22.215",
      "y2": "45.05",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FE4F45"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".52",
      "stop-color": "#F87900"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#F8B700"
    }
  })], 1), _c('linearGradient', {
    attrs: {
      "id": "paint2_linear",
      "x1": "4",
      "y1": "28",
      "x2": "52",
      "y2": "28",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FE4F45"
    }
  }), _c('stop', {
    attrs: {
      "offset": ".52",
      "stop-color": "#F87900"
    }
  }), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#F8B700"
    }
  })], 1)], 1)])]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  props: {
    size: {
      type: Number,
      "default": 66
    },
    color: {
      type: String,
      "default": '#797088'
    }
  },
  computed: {
    styles: function styles() {
      return {
        top: "calc(50% - ".concat(this.size / 2, "px)"),
        left: "calc(50% - ".concat(this.size / 2, "px)"),
        width: this.size + 'px',
        height: this.size + 'px'
      };
    }
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "rss-ui-spinner",
    style: _vm.styles
  }, [_c('svg', {
    staticClass: "rss-ui-spinner__svg",
    attrs: {
      "width": _vm.size + 'px',
      "height": _vm.size + 'px',
      "fill": "none",
      "viewBox": '0 0 ' + _vm.size + ' ' + _vm.size,
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    staticClass: "rss-ui-spinner__svg-item",
    attrs: {
      "x": "9",
      "rx": "1",
      "width": "2",
      "height": "5",
      "fill": _vm.color
    }
  }), _c('rect', {
    staticClass: "rss-ui-spinner__svg-item",
    attrs: {
      "y": "2",
      "rx": "1",
      "width": "2",
      "x": "16.535",
      "height": "5",
      "fill": _vm.color,
      "transform": "rotate(45 16.535 2)"
    }
  }), _c('rect', {
    staticClass: "rss-ui-spinner__svg-item",
    attrs: {
      "x": "15",
      "y": "11",
      "rx": "1",
      "width": "2",
      "height": "5",
      "fill": _vm.color,
      "transform": "rotate(-90 15 11)"
    }
  }), _c('rect', {
    staticClass: "rss-ui-spinner__svg-item",
    attrs: {
      "x": "13",
      "rx": "1",
      "width": "2",
      "y": "14.414",
      "height": "5",
      "fill": _vm.color,
      "transform": "rotate(-45 13 14.414)"
    }
  }), _c('rect', {
    staticClass: "rss-ui-spinner__svg-item",
    attrs: {
      "x": "9",
      "y": "15",
      "rx": "1",
      "width": "2",
      "height": "5",
      "fill": _vm.color
    }
  }), _c('rect', {
    staticClass: "rss-ui-spinner__svg-item",
    attrs: {
      "y": "13",
      "rx": "1",
      "x": "5.536",
      "width": "2",
      "height": "5",
      "fill": _vm.color,
      "transform": "rotate(45 5.536 13)"
    }
  }), _c('rect', {
    staticClass: "rss-ui-spinner__svg-item",
    attrs: {
      "y": "11",
      "rx": "1",
      "width": "2",
      "height": "5",
      "fill": _vm.color,
      "transform": "rotate(-90 0 11)"
    }
  }), _c('rect', {
    staticClass: "rss-ui-spinner__svg-item",
    attrs: {
      "x": "2",
      "rx": "1",
      "y": "3.414",
      "width": "2",
      "height": "5",
      "fill": _vm.color,
      "transform": "rotate(-45 2 3.414)"
    }
  })])]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var script = {
  components: {
    Logo: __vue_component__$2,
    Spinner: __vue_component__$1
  },
  props: {
    tooltip: {
      type: String,
      "default": undefined
    },
    tooltipPosition: {
      type: String,
      "default": 'top'
    },
    hasTooltip: {
      type: Boolean,
      "default": false
    },
    text: {
      type: String,
      "default": undefined
    },
    to: {
      type: String,
      "default": undefined
    },
    href: {
      type: String,
      "default": undefined
    },
    type: {
      type: String,
      "default": 'default'
    },
    size: {
      type: String,
      "default": 'medium'
    },
    textSize: {
      type: Number,
      "default": undefined
    },
    textColor: {
      type: String,
      "default": undefined
    },
    textBackground: {
      type: String,
      "default": ''
    },
    width: {
      type: Number,
      "default": null
    },
    rounded: Boolean,
    outlined: Boolean,
    rainbow: Boolean,
    wide: Boolean,
    shadow: Boolean,
    disabled: Boolean,
    loading: Boolean,
    blank: {
      type: Boolean,
      "default": true
    },
    icon: {
      type: String,
      "default": undefined
    },
    iconType: {
      type: String,
      "default": undefined
    },
    iconPosition: {
      type: String,
      "default": 'left'
    },
    iconOpacity: {
      type: Number,
      "default": 100
    },
    iconFixed: Boolean,
    isRssFeedButton: {
      type: Boolean,
      "default": false
    },
    dataTestId: String
  },
  data: function data() {
    return {
      upHere: false
    };
  },
  computed: {
    tag: function tag() {
      if (this.to) {
        return 'nuxt-link';
      }

      if (this.href) {
        return 'a';
      }

      return 'button';
    },
    buttonClass: function buttonClass() {
      var _ref;

      return _ref = {
        'rss-ui-button': true
      }, _defineProperty(_ref, 'rss-ui-button_' + this.type, true), _defineProperty(_ref, 'rss-ui-button_' + this.size, true), _defineProperty(_ref, 'rss-ui-button_rss', this.isRssFeedButton), _defineProperty(_ref, 'rss-ui-button_shadow', this.shadow), _defineProperty(_ref, 'rss-ui-button_rounded', this.rounded), _defineProperty(_ref, 'rss-ui-button_outlined', this.outlined), _defineProperty(_ref, 'rss-ui-button_rainbow', this.rainbow), _defineProperty(_ref, 'rss-ui-button_flat', this.flat), _defineProperty(_ref, 'rss-ui-button_wide', this.wide), _defineProperty(_ref, 'rss-ui-button_icon', this.icon || this.isRssFeedButton), _defineProperty(_ref, 'rss-ui-button_icon-fixed', this.iconFixed), _defineProperty(_ref, 'rss-ui-button_reverse', this.iconPosition === 'right'), _defineProperty(_ref, 'rss-ui-button_disabled', this.disabled || this.loading), _defineProperty(_ref, 'rss-ui-button_loading', this.loading), _ref;
    },
    tooltipClasses: function tooltipClasses() {
      return _defineProperty({}, 'rss-ui-button__tooltip_' + this.tooltipPosition, true);
    },
    iconSize: function iconSize() {
      switch (this.size) {
        case 'small':
          return 14;

        case 'big':
          return 18;
      }

      return 16;
    },
    textStyle: function textStyle() {
      return {
        'background-color': !this.textBackground ? undefined : this.textBackground,
        'font-size': !this.textSize ? undefined : this.textSize + 'px',
        color: this.textColor
      };
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      if (this.disabled) {
        e.preventDefault();
      }

      if (!this.disabled) {
        this.$emit('on-click');
      }
    },
    onMouseOver: function onMouseOver() {
      this.upHere = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.upHere = false;
    }
  }
};

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "rss-ui-button-wrapper",
    style: _vm.width === null ? undefined : 'width: ' + _vm.width + 'px',
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseleave": _vm.onMouseLeave
    }
  }, [_c('transition', {
    attrs: {
      "name": "vuejs-animation-fade"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hasTooltip && _vm.tooltip && _vm.upHere,
      expression: "hasTooltip && tooltip && upHere"
    }],
    staticClass: "rss-ui-button__tooltip",
    "class": _vm.tooltipClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.tooltip)
    }
  })]), _c(_vm.tag, {
    tag: "component",
    "class": _vm.buttonClass,
    style: _vm.width === null ? undefined : 'width: ' + _vm.width + 'px',
    attrs: {
      "to": _vm.to && !_vm.disabled ? _vm.to : false,
      "href": _vm.href ? _vm.href : false,
      "target": _vm.href && _vm.blank ? '_blank' : undefined,
      "rel": _vm.href ? 'noopener' : false,
      "data-testid": _vm.dataTestId
    },
    on: {
      "click": _vm.handleClick,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleClick.apply(null, arguments);
      }
    }
  }, [_vm.isRssFeedButton ? _c('Logo', {
    staticClass: "rss-ui-button__logo",
    attrs: {
      "width": 25,
      "height": 25,
      "simple": true
    }
  }) : _vm._e(), _vm._t("icon"), _c('span', {
    staticClass: "rss-ui-button__text",
    style: _vm.textStyle
  }, [_vm.$slots["default"] && !_vm.text ? _vm._t("default") : _vm.text ? [_vm._v(_vm._s(_vm.text))] : _vm._e()], 2), _vm.loading ? _c('span', {
    staticClass: "rss-ui-button__loader"
  }, [_c('Spinner', {
    staticClass: "rss-ui-button__loader-spinner",
    attrs: {
      "size": 20,
      "color": '#fff'
    }
  })], 1) : _vm._e()], 2)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RssUiLogo: __vue_component__$2,
  RssUiButton: __vue_component__,
  RssUiSpinner: __vue_component__$1
});

/*
 * List of services: ga, facebook, drip, mixpanel
*/

var EventSystem = /*#__PURE__*/_createClass(function EventSystem(env) {
  _classCallCheck(this, EventSystem);

  // Google Analytics
  this.GA = {
    send: function send(event, data) {

      var requestData = _objectSpread2({
        env: env
      }, data);

      if (event) {
        requestData.event = event;
      } // eslint-disable-next-line


      window.dataLayer = window.dataLayer || []; // eslint-disable-next-line

      window.dataLayer.push(requestData);
    }
  }; // Facebook Pixel

  this.Facebook = {
    send: function send(event, additionalData) {

      var data = additionalData || {};

      try {
        // eslint-disable-next-line
        fbq('track', event, data);
      } catch (error) {}
    }
  }; // Drip

  this.Drip = {
    identify: function identify(email, userId) {

      try {
        // eslint-disable-next-line
        _dcq.push(['identify', {
          email: email,
          user_id: userId
        }]);
      } catch (error) {}
    },
    send: function send(event, data) {

      try {
        var additionalData = data || {};

        if (additionalData.userId) {
          additionalData.user_id = additionalData.userId;
          delete additionalData.userId;
        } // eslint-disable-next-line


        _dcq.push(['track', event, _objectSpread2({
          occured_at: new Date()
        }, additionalData)]);
      } catch (error) {}
    }
  }; // Mixpanel

  this.Mixpanel = {
    identify: function identify(userId) {

      try {
        // eslint-disable-next-line
        mixpanel.identify(userId);
      } catch (error) {}
    },
    setUser: function setUser(email, userId) {

      try {
        // eslint-disable-next-line
        mixpanel.people.set({
          $email: email,
          'Sign up date': new Date(),
          USER_ID: userId
        });
      } catch (error) {}
    },
    send: function send(event, data) {

      try {
        var additionalData = data || {}; // eslint-disable-next-line

        mixpanel.track(event, _objectSpread2({}, additionalData));
      } catch (error) {}
    }
  };
});

var install = function installRssUi(Vue) {
  if (install.installed) return;
  install.installed = true;
  Object.entries(components).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        componentName = _ref2[0],
        component = _ref2[1];

    Vue.component(componentName, component);
  });
}; // Create module definition for Vue.use()


var plugin = {
  install: install
}; // To auto-install on non-es builds, when vue is found

export { EventSystem, __vue_component__ as RssUiButton, __vue_component__$2 as RssUiLogo, __vue_component__$1 as RssUiSpinner, plugin as default };
